export default __webpack_public_path__ + "static/media/header_comefunziona.5e38ec37.png";